import type { Dictionary } from '../../i18n/dictionary';
import { plural } from '../../i18n/plural';

const pl = {
  appName: 'Finanse',
  overview: 'Przegląd',
  wallets: 'Portfele',
  goals: 'Cele',

  overviewTitle: 'Przegląd — Finanse — ITLamb',
  totalBalance: 'Saldo łączne',
  totalTargets: 'Suma celów',
  shortfall: 'Niedobór',
  unallocated: 'Nieprzydzielone',
  goal: 'Cel',
  target: 'Kwota docelowa',
  targetMonth: 'Miesiąc docelowy',
  allocated: 'Przydzielone',
  status: 'Status',
  funded: 'sfinansowany',
  short: (amount: string) => `brakuje ${amount}`,
  monthsLeft: (n: number) =>
    `${n} ${plural(n, 'miesiąc', 'miesiące', 'miesięcy')} do końca`,
  noGoals: 'Brak celów.',

  walletsTitle: 'Portfele — Finanse — ITLamb',
  addWallet: 'Nowy portfel',
  name: 'Nazwa',
  balance: 'Saldo',
  add: 'Dodaj',
  save: 'Zapisz',
  cancel: 'Anuluj',
  editWallet: (name: string) => `Edytuj portfel ${name}`,
  deleteWallet: (name: string) => `Usuń portfel ${name}`,
  confirmDeleteWallet: (name: string) => `Usunąć portfel „${name}”?`,
  noWallets: 'Brak portfeli.',

  goalsTitle: 'Cele — Finanse — ITLamb',
  savingsGoals: 'Cele oszczędnościowe',
  addGoal: 'Nowy cel',
  targetAmount: 'Kwota docelowa',
  editGoal: (name: string) => `Edytuj cel ${name}`,
  deleteGoal: (name: string) => `Usuń cel ${name}`,
  confirmDeleteGoal: (name: string) => `Usunąć cel „${name}”?`,

  loadWalletsFailed: 'Nie udało się wczytać portfeli.',
  loadGoalsFailed: 'Nie udało się wczytać celów.',
  loadOverviewFailed: 'Nie udało się wczytać przeglądu.',
  createWalletFailed: 'Nie udało się dodać portfela.',
  saveWalletFailed: 'Nie udało się zapisać portfela.',
  walletSaved: 'Portfel zapisany.',
  deleteWalletFailed: 'Nie udało się usunąć portfela.',
  createGoalFailed: 'Nie udało się dodać celu.',
  saveGoalFailed: 'Nie udało się zapisać celu.',
  goalSaved: 'Cel zapisany.',
  deleteGoalFailed: 'Nie udało się usunąć celu.',
};

const en: typeof pl = {
  appName: 'Finances',
  overview: 'Overview',
  wallets: 'Wallets',
  goals: 'Goals',

  overviewTitle: 'Overview — Finances — ITLamb',
  totalBalance: 'Total balance',
  totalTargets: 'Total targets',
  shortfall: 'Shortfall',
  unallocated: 'Unallocated',
  goal: 'Goal',
  target: 'Target',
  targetMonth: 'Target month',
  allocated: 'Allocated',
  status: 'Status',
  funded: 'funded',
  short: (amount) => `short ${amount}`,
  monthsLeft: (n) => `${n} mo left`,
  noGoals: 'No goals yet.',

  walletsTitle: 'Wallets — Finances — ITLamb',
  addWallet: 'Add wallet',
  name: 'Name',
  balance: 'Balance',
  add: 'Add',
  save: 'Save',
  cancel: 'Cancel',
  editWallet: (name) => `Edit wallet ${name}`,
  deleteWallet: (name) => `Delete wallet ${name}`,
  confirmDeleteWallet: (name) => `Delete wallet "${name}"?`,
  noWallets: 'No wallets yet.',

  goalsTitle: 'Goals — Finances — ITLamb',
  savingsGoals: 'Savings goals',
  addGoal: 'Add goal',
  targetAmount: 'Target amount',
  editGoal: (name) => `Edit goal ${name}`,
  deleteGoal: (name) => `Delete goal ${name}`,
  confirmDeleteGoal: (name) => `Delete goal "${name}"?`,

  loadWalletsFailed: 'Could not load wallets.',
  loadGoalsFailed: 'Could not load goals.',
  loadOverviewFailed: 'Could not load the overview.',
  createWalletFailed: 'Could not add the wallet.',
  saveWalletFailed: 'Could not save the wallet.',
  walletSaved: 'Wallet saved.',
  deleteWalletFailed: 'Could not delete the wallet.',
  createGoalFailed: 'Could not add the goal.',
  saveGoalFailed: 'Could not save the goal.',
  goalSaved: 'Goal saved.',
  deleteGoalFailed: 'Could not delete the goal.',
};

export const financesDict: Dictionary<typeof pl> = { pl, en };
